import { getSiteConfiguration } from "@/src/utils/configUtils";

//检测mkq是否加载完成
function mkqLoadedPromise(): Promise<boolean> {
    let timer: NodeJS.Timeout;
    let attempts = 0;
    const maxAttempts = 200; // 10 seconds / 50ms = 200 attempts
    return new Promise((rev, rej) => {
        if (window && window.mkq) {
            rev(true);
        } else {
            timer = setInterval(() => {
                attempts++;
                if (window && window.mkq) {
                    rev(true);
                    clearInterval(timer);
                } else if (attempts >= maxAttempts) {
                    rej(false);
                    console.log("mkq not loaded");
                    clearInterval(timer);
                }
            }, 50);
        }
    });
}

interface TrackEventData {
    [key: string]: any; //
    content_ids?: number[]; //
    value?: number;
    currency?: string;
    contents?: {
        [key: string]: any;
        id?: string | number;
        quantity?: number;
    }[];
}

class Cybertargeter {
    initStatus: boolean = false;

    init(domain: string) {
        const CybertargeterPixel = getSiteConfiguration(
            "CybertargeterPixel",
            domain,
        );
        const head = document.getElementsByTagName("HEAD").item(0);

        if (!CybertargeterPixel || !head) {
            return;
        }
        const label = document.createElement("script");
        label.type = "text/javascript";
        label.innerHTML = `!function(w,o,s,r,p,k,e){if(w.mkq){return}p=w.mkq=function(){p.invokeFunc?p.invokeFunc.apply(p,arguments):p.qu.push(arguments)};if(!w._mkq){w._mkq=p}p.push=p;p.qu=[];k=o.createElement(s);k.async=!0;k.src=r;e=o.getElementsByTagName(s)[0];e.parentNode.insertBefore(k,e)}(window,document,"script","//pixeltrack.clientgear.com/mkq.min.js");
                              mkq('init', '${CybertargeterPixel}');
                              mkq('track', "PageView", {
                              title: document.title
                          });`;
        head.appendChild(label);
        this.initStatus = true;
    }

    TrackEvent(event: string, data: TrackEventData): void {
        if (!this.initStatus) {
            return;
        }
        mkqLoadedPromise().then(() => {
            console.log("CybertargeterPixel", event, data);
            window.mkq("track", event, data);
        });
    }

    //查看商品分类页面
    ViewCategory(data: TrackEventData): void {
        this.TrackEvent("ViewCategory", data);
    }

    //查看商品详情页面
    ViewContent(data: TrackEventData): void {
        this.TrackEvent("ViewContent", data);
    }

    //添加商品到购物车
    AddToCart(data: TrackEventData): void {
        this.TrackEvent("AddToCart", data);
    }

    //进入添加购物车页面
    ViewCart(data: TrackEventData): void {
        this.TrackEvent("ViewCart", data);
    }

    //购买或结帐流程完成后,例如登陆谢谢/确认页面
    Purchase(data: TrackEventData): void {
        this.TrackEvent("Purchase", data);
    }
}

let cybertargeter = new Cybertargeter();

export default cybertargeter;
